module.exports = __webpack_public_path__ + "img/groupe-24.19115c5a.svg";